import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {IFeatchAccountNftsParams, IFeatchNftsResponse, INft, NftType, ProviderKind} from "../bean/OpenseaBean";
import {IOpenseaAssetItem} from "../bean/OpenseaBean";
import {IOpenseaConfig} from "../env";
import {ILogger} from "../logger";

interface IOpenseaResponseData {
    next: string | null | undefined
    previous: string | null | undefined
    assets: IOpenseaAssetItem[] | undefined
}

export class OpenseaApi {
    private readonly _logger: ILogger
    private readonly _baseUrl: string
    private readonly _apiKey: string

    constructor(logger: ILogger, config: IOpenseaConfig) {
        this._logger = logger
        this._baseUrl = `${config.apiUrl}`
        this._apiKey = config.apiKey
    }

    async fetchAccountNFTS(params: IFeatchAccountNftsParams): Promise<IFeatchNftsResponse> {

        const {ownerAddress, tokenAddresses, cursor} = params

        let urlParams = new URLSearchParams();
        urlParams.append('owner', params.ownerAddress);

        if (tokenAddresses && tokenAddresses.length > 0) {
            urlParams.append('asset_contract_address', tokenAddresses[0])
            if (tokenAddresses.length > 1) {
                this._logger.warn('Token addresses filter has more than one item. Opensea V2 api support only one item')
            }
        }

        let url = this._baseUrl;
        if (cursor) {
            // don't use urlParams.append to prevent url encode
            url = `${url}?cursor=${cursor}`
        }

        url = `${url}?limit=${params.limit}`;

        const config: AxiosRequestConfig = {params: urlParams,timeout:15000}

        const response: AxiosResponse<IOpenseaResponseData> | undefined = await axios.get<IOpenseaResponseData, AxiosResponse<IOpenseaResponseData>>(url, config);

        // console.log(response)
        let next = undefined
        let pageData: INft[] = []
        if (response) {
            const results = response.data.assets
            next = response.data.next
            if (results) {
                results.forEach(x => {
                    const schema = x.asset_contract.schema_name.toUpperCase()
                    if (schema === 'ERC721' || schema === 'ERC1155') {
                        pageData.push(this.mapNft(x))
                    }
                })
            }
        }

        // let pageData: INft[] = [{
        //     tokenAddress: "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d",
        //     tokenId: "1",
        //     projectName: "BAYC",
        //     image: "",
        //     imageProvider: ProviderKind.OpenseaV2,
        //     contractType: NftType.ERC721,
        //     amount: 1,
        //     description: "description",
        //     nftName: "BAYC1",
        //     symbol: "symbol",
        //     rawData: ""
        // },
        //     {
        //         tokenAddress: "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d",
        //         tokenId: "2",
        //         projectName: "BAYC",
        //         image: "",
        //         imageProvider: ProviderKind.OpenseaV2,
        //         contractType: NftType.ERC721,
        //         amount: 1,
        //         description: "description",
        //         nftName: "BAYC2",
        //         symbol: "symbol",
        //         rawData: ""
        //     }];

        return {
            page: 1,
            pageSize: pageData.length,
            total: 0,
            data: pageData,
            cursor: this.parseCursor(next)
        }

    }


    private mapNft(openseaItem: IOpenseaAssetItem): INft {

        const {asset_contract} = openseaItem
        const assetSchema = asset_contract.schema_name.toUpperCase()

        let amount = -1
        let contractType = NftType.ERC1155

        if (assetSchema === 'ERC721') {
            amount = 1
            contractType = NftType.ERC721
        }

        return {
            tokenAddress: asset_contract.address,
            tokenId: openseaItem.token_id,
            projectName: asset_contract.name,
            image: openseaItem.image_url,
            imageProvider: ProviderKind.Opensea,
            contractType: contractType,
            // it doesnt support amount =((
            amount: amount,
            description: openseaItem.description,
            nftName: openseaItem.name,
            symbol: asset_contract.symbol,
            rawData: asset_contract
        }
    }

    private parseCursor(cursorUrl: string | null | undefined): string | undefined {

        if (cursorUrl) {
            const cursorParam = 'cursor='
            const startIndex = cursorUrl.indexOf(cursorParam) + cursorParam.length
            if (startIndex === -1) {
                return undefined
            }
            const endIndex = cursorUrl.indexOf('&', startIndex)

            return cursorUrl.substring(startIndex, endIndex === -1 ? undefined : endIndex)
        }

        return undefined
    }

}
